import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const HERO_IMG = "/photos/heart-stones.webp";

const fade = (d) => ({ initial: { opacity: 0, y: 24 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.9, delay: d, ease: [0.22, 1, 0.36, 1] } });

export const Hero = () => (
  <section id="top" className="relative overflow-hidden" data-testid="hero-section">
    <div className="mx-auto grid max-w-7xl gap-14 px-6 pb-20 pt-16 lg:grid-cols-12 lg:px-10 lg:pb-28 lg:pt-24">
      <div className="lg:col-span-7">
        <motion.p {...fade(0)} className="mb-8 flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-primary">
          <span className="h-px w-10 bg-gold" /> An ecology for lifelong learning
        </motion.p>
        <motion.h1 {...fade(0.1)} className="font-display text-5xl font-extrabold leading-[1.02] tracking-tighter text-foreground sm:text-6xl" data-testid="hero-headline">
          Learning, healing &amp; contribution.{" "}
          <span className="block text-primary">Learning is healing. Healing is learning.</span>
        </motion.h1>
        <motion.p {...fade(0.2)} className="mt-8 max-w-xl text-base leading-relaxed text-foreground/75 sm:text-lg" data-testid="hero-subcopy">
          At Nia Ecoversity, meaningful ecological learning brings healing and contribution into the same journey. Here, we
          keep learning, become more fully ourselves, and give back to the communities and living world we belong to.
        </motion.p>
        <motion.div {...fade(0.3)} className="mt-12 flex flex-wrap items-center gap-6">
          <Link to="/contact" data-testid="hero-enquire-button"
            className="group inline-flex items-center gap-3 rounded-sm bg-primary px-8 py-4 text-sm font-semibold text-primary-foreground transition-transform duration-300 hover:-translate-y-1">
            Start a conversation
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
          <Link to="/offerings" data-testid="hero-offerings-link"
            className="text-sm font-semibold text-primary underline decoration-gold decoration-2 underline-offset-8 transition-colors hover:text-primary">
            Explore what we offer
          </Link>
        </motion.div>
      </div>
      <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 1.2, delay: 0.2 }}
        className="relative lg:col-span-5">
        <div className="absolute -left-6 -top-6 h-40 w-40 rounded-sm bg-gold/20 blur-2xl" aria-hidden="true" />
        <div className="relative overflow-hidden rounded-sm">
          <img src={HERO_IMG} alt="An open hand holding two heart-shaped stones by the water's edge" className="h-[460px] w-full object-cover lg:h-[580px]" data-testid="hero-image" />
        </div>
        <img src="/brand/nia-icon.png" alt="" aria-hidden="true"
          className="absolute -bottom-10 -left-8 h-28 w-auto rounded-sm bg-background p-4 sm:h-32" />
      </motion.div>
    </div>
  </section>
);
